import React, { Component } from 'react'
import { MultiPeriodRulesComponent } from './'
import lodashUtil from 'lodash';
import { MuiGrid } from '../../../../../ui';
import { ConstraintsAndPreferences, CalculateUtil, DialogComponentUtil } from '..';
import { toast } from 'react-toastify';
class MultiPeriodRulesContainer extends Component {
	constructor(props) {
		super(props)

		let cellData = this.props.dataTableMap.get(this.props.cellCode)
		let multiPeriod = undefined

		if (cellData.elective !== undefined) {
			multiPeriod = {
				electiveName: cellData.elective.name,
				electiveId: cellData.elective._id,
				preferences: [
					{
						noOfStandardPeriods: 1,
						numberOfInstances: 2,
					}
				]
			}
		} else {
			multiPeriod = {
				subjectId: cellData.subject._id,
				subjectName: cellData.subject.name,
				subjectCode: cellData.subject.code,
				preferences: [
					{
						noOfStandardPeriods: 1,
						numberOfInstances: 2,
					}
				]
			}

		}
		this.state = {
			tempActiveSchool: JSON.parse(JSON.stringify(this.props.activeSchool)),
			keyArray: [],
			MPObject: JSON.parse(JSON.stringify(this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].multiPeriods)),
			preferencesObj: [],
			multiPeriod: JSON.parse(JSON.stringify(multiPeriod)),
			indexArray: [],
		}
	}

	componentDidMount() {
		this.showExistingMultiperiods()
	}

	showExistingMultiperiods = () => {
		if (this.props.activeSchool.schedule_constraints !== undefined) {
			let preferences = this.state.multiPeriod.preferences;
			let multiPeriods = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].multiPeriods
			if (multiPeriods !== undefined && multiPeriods.length > 0) {
				let celldetails = this.props.dataTableMap.get(this.props.cellCode)
				// groups is not present

				if (this.props.filter.showSections === false && celldetails.groups === undefined) {
					for (let b = 0; b < multiPeriods.length; b++) {
						if (multiPeriods[b].gradeDetails.grades[0].groups.length === 0) {
							if ((celldetails.subject && celldetails.subject._id == multiPeriods[b].subjectId) || (celldetails.elective && celldetails.elective._id == multiPeriods[b].electiveId)) {
								let grade = multiPeriods[b].gradeDetails.grades
								let isObjectPresent = lodashUtil.find(grade, ['grade', celldetails.grade])
								if (isObjectPresent !== undefined) {
									if (isObjectPresent.groups.length === 0) {
										let multiPeriodObj = JSON.parse(JSON.stringify(multiPeriods[b]))
										delete multiPeriodObj.gradeDetails
										this.setState({
											multiPeriod: multiPeriodObj
										})
									}
								}
							}
						}
					}
				}
				// group is present
				if (this.props.filter.showSections === true && celldetails.group !== undefined) {
					for (let c = 0; c < multiPeriods.length; c++) {
						if (multiPeriods[c].gradeDetails.grades[0].groups.length !== 0) {
							if ((celldetails.subject && celldetails.subject._id == multiPeriods[c].subjectId) || (celldetails.elective && celldetails.elective._id == multiPeriods[c].electiveId)) {
								let grades = multiPeriods[c].gradeDetails.grades
								let isObjPresent = lodashUtil.find(grades, ['grade', celldetails.grade])
								if (isObjPresent !== undefined) {
									let groupCode = isObjPresent.groups[0].groupCode
									if (groupCode === celldetails.group) {
										let multiPeriodObj = JSON.parse(JSON.stringify(multiPeriods[c]))
										delete multiPeriodObj.gradeDetails
										this.setState({
											multiPeriod: multiPeriodObj
										})
									}
								}
							}
						}

					}
				}
			}
		}
	}

	handleChange = (value, name, index) => {
		let tempObj = { ...this.state.multiPeriod }
		tempObj.preferences[index][name] = value;
		this.setState({ multiPeriod: tempObj });
	}

	getMultiPeriodString = (multiPeriod) => {
		let preferencesArray = [];
		for (let i = 0; i < multiPeriod.preferences.length; i++) {
			let noOfStandardPeriods = multiPeriod.preferences[i].noOfStandardPeriods
			let numberOfInstances = multiPeriod.preferences[i].numberOfInstances
			preferencesArray.push(`${noOfStandardPeriods}-${numberOfInstances}`)
		}
		let showMultiPeriodString = preferencesArray.toString()
		return showMultiPeriodString
	}

	onClickOfSave = async () => {
		let validation = this.validationForMultiPeriodsLength();
		if (validation === true) {
			let tempActiveSchool = this.state.tempActiveSchool;
			let keys = this.props.keys;
			let cellDetails = undefined;
			let gradeLevels = this.props.activeSchool.school_master.gradeLevels
			let objMatching = false;
			let templetObjForCreatingNewObj = undefined;
			let multiPeriods = tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].multiPeriods
			let multiPeriod = JSON.parse(JSON.stringify(this.state.multiPeriod));
			multiPeriod.showMultiPeriodString = this.getMultiPeriodString(multiPeriod);
			if (lodashUtil.isEmpty(this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex])) {
				tempActiveSchool.schedule_constraints = [
					{ multiPeriods: [] }
				]
			}

			//KEYS 
			for (let c = 0; c < keys.length; c++) {
				cellDetails = this.props.dataTableMap.get(keys[c]);
				// gradeDetails from subject or elective 
				let cellGradeDetails = undefined;
				if (cellDetails.subject !== undefined) {
					cellGradeDetails = cellDetails.subject.gradeDetails
				} else if (cellDetails.elective !== undefined) {
					cellGradeDetails = cellDetails.elective.gradeDetails
				}
				// "EDIT" if multiPeriod is already present 
				if (cellDetails.multiPeriod !== undefined) {
					//EDITING FOR GROUPS
					if (this.props.filter.showSections === true) {
						let count = 0;
						let index = undefined;
						let cellDetails_multiPeriod = cellDetails.multiPeriod

						let preferences = multiPeriod.preferences
						let objIndex = DialogComponentUtil.findConstraintObjIndexToReplace(multiPeriods, cellDetails_multiPeriod)
						if (objIndex === undefined) {
							objMatching = false
						} else {
							let obj = multiPeriods[objIndex]
							// checking if the length is same first
							if (obj.preferences.length === preferences.length) {
								// checking if the values are same
								for (let x = 0; x < preferences.length; x++) {
									let preferences_noOfStandardPeriods = preferences[x].noOfStandardPeriods;
									let preferences_numberOfInstances = preferences[x].numberOfInstances;
									let obj_noOfStandardPeriods = obj.preferences[x].noOfStandardPeriods;
									let obj_numberOfInstances = obj.preferences[x].numberOfInstances;
									if (preferences_noOfStandardPeriods === obj_noOfStandardPeriods && preferences_numberOfInstances === obj_numberOfInstances) {
										objMatching = true;
										break;
									}
								}
							} else {
								objMatching = false;
							}
						}

						if (objMatching === false) {
							// remove obj code 
							for (let d = 0; d < multiPeriods.length; d++) {
								let gradeObj = multiPeriods[d].gradeDetails.grades[0]
								if ((cellDetails.subject && cellDetails.subject._id == multiPeriods[d].subjectId) || (cellDetails.elective && cellDetails.elective._id == multiPeriods[d].electiveId)) {
									if (gradeObj.grade === cellDetails.grade) {
										count++
										if (gradeObj.groups.length === 0) {
											index = d;
										}
									}
								}
							}
							// SPLICE
							let subGradeObj;
							let isLevelPresent = lodashUtil.find(cellGradeDetails.gradeLevels, ['level', cellDetails.gradeLevel])
							if (isLevelPresent !== undefined) {
								let gradeLevelObj = lodashUtil.find(gradeLevels, ['levelName', cellDetails.gradeLevel])
								if (gradeLevelObj !== undefined)
									subGradeObj = lodashUtil.find(gradeLevelObj.grades, ["gradeName", cellDetails.grade]);
							} else {
								subGradeObj = lodashUtil.find(cellGradeDetails.grades, ["grade", cellDetails.grade]);
							}
							// check if the SUBJECT is present for all the grade if not for all the GROUPS fro the selected GRADE.
							if (cellGradeDetails.allGrades === true || subGradeObj.groups.length === 0) {
								for (let p = 0; p < gradeLevels.length; p++) {
									let gradeLevel = gradeLevels[p]
									let selectedObj = lodashUtil.find(gradeLevel.grades, ["gradeName", cellDetails.grade])
									if (selectedObj !== undefined) {
										if ((count === (selectedObj.groups.length + 1)) && index !== undefined) {
											multiPeriods.splice(index, 1);
											break;
										}
									}
								}
							}
							// SUBJECT is there only for SOME GROUPS in that grade.
							else {
								if ((count === (subGradeObj.groups.length + 1)) && index !== undefined) {
									multiPeriods.splice(index, 1);
								}
							}
						}
						//REPLACING the group Object if the object is already there.
						let objectIndex = DialogComponentUtil.findConstraintObjIndexToReplace(multiPeriods, cellDetails_multiPeriod)
						if (objectIndex !== undefined) {
							multiPeriods[objectIndex].preferences = JSON.parse(JSON.stringify(multiPeriod.preferences))
							multiPeriods[objectIndex].showMultiPeriodString = JSON.parse(JSON.stringify(multiPeriod.showMultiPeriodString))
						}
					}
					//"GRADES" show sections is false so we are clicking on grades which already has the data 
					else {
						let cellDetails_multiPeriod = cellDetails.multiPeriod
						let preferences = multiPeriod.preferences
						let objMatching = false;

						let objectIndex = DialogComponentUtil.findConstraintObjIndexToReplace(multiPeriods, cellDetails_multiPeriod)
						if (objectIndex === undefined) {
							objMatching = false
						} else {
							let obj = multiPeriods[objectIndex];
							if (obj && obj.preferences.length === preferences.length) {
								let isStdPeriod = lodashUtil.differenceBy(obj.preferences, preferences, "noOfStandardPeriods");
								if (isStdPeriod.length === 0) {
									let isInstances = lodashUtil.differenceBy(obj.preferences, preferences, "numberOfInstances");
									if (isInstances.length === 0) {
										objMatching = true;
									}
								}
							}
						}
						if (objMatching === false) {
							//all the groups should eb over ridden with this value
							for (let h = 0; h < multiPeriods.length; h++) {

								if ((cellDetails.subject && cellDetails.subject._id == multiPeriods[h].subjectId)
									|| (cellDetails.elective && cellDetails.elective._id == multiPeriods[h].electiveId)) {

									if (multiPeriods[h].gradeDetails.grades[0].grade === cellDetails.grade) {
										multiPeriods[h].preferences = JSON.parse(JSON.stringify(multiPeriod.preferences));
										multiPeriods[h].showMultiPeriodString = multiPeriod.showMultiPeriodString;

										if (multiPeriods[h].gradeDetails.grades[0].groups.length != 0) {
											if (templetObjForCreatingNewObj === undefined) {
												templetObjForCreatingNewObj = JSON.parse(JSON.stringify(multiPeriods[h]))
											}
										}

									}

								}
							}
						}
						this.creatingMultPeriodObjForJointClass(templetObjForCreatingNewObj, cellDetails, tempActiveSchool)
					}
				}

				//"NEW OBJECT" if multiPeriod is not present in the schedule constraint
				else {
					// if the selected cell is for the grade and not for groups
					if (cellDetails.group === undefined) {
						//grade's object from master
						for (let g = 0; g < gradeLevels.length; g++) {
							let gradeObj = lodashUtil.find(gradeLevels[g].grades, ['gradeName', cellDetails.grade]);
							//GRADE (groups is empty)
							if (gradeObj !== undefined) {
								let multiPeriodObject = JSON.parse(JSON.stringify(multiPeriod))
								let gradeDetails = {
									allGrades: false,
									gradeLevels: [{
										level: cellDetails.gradeLevel
									}],
									grades: [{
										grade: cellDetails.grade,
										groups: [],
									}],
								}
								multiPeriodObject.gradeDetails = gradeDetails;

								//attaching data to the particular cell
								tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].multiPeriods.push(multiPeriodObject);

								let existingGroupArray = [];
								for (let x = 0; x < multiPeriods.length; x++) {
									if ((cellDetails.subject && cellDetails.subject._id == multiPeriods[x].subjectId) || (cellDetails.elective && cellDetails.elective._id == multiPeriods[x].electiveId)) {
										if (multiPeriods[x].gradeDetails.grades[0].grade === cellDetails.grade && multiPeriods[x].gradeDetails.grades[0].groups.length > 0) {
											existingGroupArray.push(multiPeriods[x].gradeDetails.grades[0].groups[0].groupCode)
											multiPeriods[x].preferences = JSON.parse(JSON.stringify(multiPeriod.preferences));
											multiPeriods[x].showMultiPeriodString = multiPeriod.showMultiPeriodString;

											if (templetObjForCreatingNewObj === undefined) {
												templetObjForCreatingNewObj = JSON.parse(JSON.stringify(multiPeriods[x]))
											}
										}
									}
								}
								// to create NEW data to all the groups  
								//  VALIDATIONS if the subject or elective has gradeDetails ALL GRADE = TRUE or there is NO GROUPS for the grade
								let commonGradeObj;
								let cellGrade = lodashUtil.find(cellGradeDetails.grades, ["grade", cellDetails.grade]);
								let gradeObj = undefined
								for (let t = 0; gradeLevels.length; t++) {
									let gradeLevel = gradeLevels[t];
									gradeObj = lodashUtil.find(gradeLevel.grades, ['gradeName', cellDetails.grade]);
									if (gradeObj !== undefined) {
										break;
									}
								}
								if (cellGradeDetails !== undefined) {
									commonGradeObj = gradeObj;
								}

								for (let m = 0; m < commonGradeObj.groups.length; m++) {
									// AFTER GRADE => GROUPS
									if (!existingGroupArray.includes(commonGradeObj.groups[m].groupName)) {
										let multiPeriodObject = JSON.parse(JSON.stringify(multiPeriod))
										let gradeDetails = {
											allGrades: false,
											gradeLevels: [{
												level: cellDetails.gradeLevel
											}],
											grades: [{
												grade: cellDetails.grade,
												groups: [{
													groupCode: commonGradeObj.groups[m].groupName !== undefined ? commonGradeObj.groups[m].groupName : commonGradeObj.groups[m].groupCode
												}],
											}],
										}
										multiPeriodObject.gradeDetails = gradeDetails;
										tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].multiPeriods.push(multiPeriodObject)

										if (templetObjForCreatingNewObj === undefined) {
											templetObjForCreatingNewObj = JSON.parse(JSON.stringify(multiPeriodObject))
										}

									}
								}
								break;
							}
						}
						this.creatingMultPeriodObjForJointClass(templetObjForCreatingNewObj, cellDetails, tempActiveSchool)
					}
					// selected cell for GROUPS
					else {
						let multiPeriodObject = JSON.parse(JSON.stringify(multiPeriod));

						let gradeDetails = {
							allGrades: false,
							gradeLevels: [{
								level: cellDetails.gradeLevel
							}],
							grades: [{
								grade: cellDetails.grade,
								groups: [
									{ groupCode: cellDetails.group }
								],
							}],
						}
						multiPeriodObject.gradeDetails = gradeDetails;
						if (cellDetails.jointClass !== undefined) {
							multiPeriodObject.jointClassId = cellDetails.jointClass._id
						}
						multiPeriods.push(multiPeriodObject)
					}
				}
			}
			tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex] = await CalculateUtil.calculateConstraintsAndPreference(tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex],
				ConstraintsAndPreferences.Constants.MULTI_PERIODS)

			this.deleteObjFromMultiPeriod()
			await this.props.updateDialogSave(tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex]);
			this.attachingDataToCell();
			this.props.handleCloseForDialog();
			this.props.handleClose();
		}
	}

	creatingMultPeriodObjForJointClass = (templetObjForCreatingNewObj, cellDetails, tempActiveSchool) => {
		let cellDetails_grade = cellDetails.grade
		let jointClassArray = tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].jointClasses
		let multiPeriodsArray = tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].multiPeriods

		//JOINT CLASS ARRAY
		for (let a = 0; a < jointClassArray.length; a++) {
			let jointClassObj = JSON.parse(JSON.stringify(jointClassArray[a]));
			if ((cellDetails.subject && cellDetails.subject._id == jointClassObj.subjectId) || (cellDetails.elective && cellDetails.elective._id == jointClassObj.electiveId)) {
				let gradeDetails_gradesArray = jointClassObj.gradeDetails.grades
				let gradeIndex = lodashUtil.findIndex(gradeDetails_gradesArray, ['grade', cellDetails_grade])
				if (gradeIndex != -1) {

					//JOINT CLASS GRADE 
					for (let b = 0; b < gradeDetails_gradesArray.length; b++) {
						let gradeObj = gradeDetails_gradesArray[b]

						// JOINT CLASS GROUPS 
						for (let c = 0; c < gradeObj.groups.length; c++) {
							let groupObj = gradeObj.groups[c];
							let isGroupObjPresent = false;

							//MULTIPERIODS FROM DATABASE
							for (let d = 0; d < multiPeriodsArray.length; d++) {
								let multiPeriodObj = multiPeriodsArray[d];
								let multiPeriodObj_grades = multiPeriodObj.gradeDetails.grades[0]
								// REPLACING THE VALUES IN THE DATABASE ARRAY
								if (multiPeriodObj_grades.grade === gradeObj.grade
									&& multiPeriodObj_grades.groups != undefined
									&& multiPeriodObj_grades.groups.length > 0
									&& multiPeriodObj_grades.groups[0].groupCode === groupObj.groupCode) {
									multiPeriodObj.preferences = JSON.parse(JSON.stringify(templetObjForCreatingNewObj.preferences))
									multiPeriodObj.showMultiPeriodString = templetObjForCreatingNewObj.showMultiPeriodString
									multiPeriodObj.jointClassId = jointClassObj._id
									isGroupObjPresent = true
									break;
								}
							}

							// CREATE NEW OBJECT FOR PARTICULAR GROUPS
							if (isGroupObjPresent === false) {
								let tempObj = JSON.parse(JSON.stringify(templetObjForCreatingNewObj));
								delete tempObj._id;
								tempObj.gradeDetails.grades[0].grade = gradeObj.grade;
								delete tempObj.gradeDetails.grades[0].grade._id;
								tempObj.gradeDetails.grades[0].groups[0].groupCode = groupObj.groupCode;
								delete tempObj.gradeDetails.grades[0].groups[0]._id;
								tempObj.jointClassId = jointClassObj._id
								multiPeriodsArray.push(tempObj);
							}
						}
					}
				}
			}
		}
	}

	attachingDataToCell = () => {
		let multiPeriods = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].multiPeriods;
		let dataTableMap = this.props.dataTableMap;
		for (let i = 0; i < multiPeriods.length; i++) {
			let grades = multiPeriods[i].gradeDetails.grades[0];
			if (this.props.filter.showSections === false) {
				if (grades.groups.length === 0) {
					for (let [key, value] of dataTableMap) {
						if ((value.subject && value.subject._id == multiPeriods[i].subjectId) || (value.elective && value.elective._id == multiPeriods[i].electiveId)) {
							if (value.grade === grades.grade) {
								value.multiPeriod = multiPeriods[i];
								dataTableMap.set(key, value);
								break;
							}
						}
					}
				}
			} else {
				if (grades.groups.length !== 0) {
					for (let [key, value] of dataTableMap) {
						if ((value.subject && value.subject._id == multiPeriods[i].subjectId) || (value.elective && value.elective._id == multiPeriods[i].electiveId)) {
							if (value.grade === grades.grade) {
								if (value.group === grades.groups[0].groupCode) {
									value.multiPeriod = multiPeriods[i];
									dataTableMap.set(key, value);
									break;
								}
							}
						}
					}
				}
			}
		}
	}



	validationForMultiPeriodsLength = () => {
		const i18n = this.props.i18n
		let validation;
		let multiPeriod = this.state.multiPeriod;
		let calendar = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].weeklyCalendar[0];
		validation = this.findingContiguousPeriod(multiPeriod, calendar);
		if (validation === false) {
			toast(i18n.multiPeriodRules.contiguousPeriods);
		} else {
			validation = this.sumOfMultiperiodsValidation(multiPeriod);
		}
		return validation;
	}

	findingContiguousPeriod = (multiPeriod, calendar) => {
		if (multiPeriod.preferences.length !== 0) {
			let maxPeriodLength = multiPeriod.preferences[0].noOfStandardPeriods;
			for (let a = 1; a < multiPeriod.preferences.lenght; a++) {
				let noOfStandardPeriods = multiPeriod.preferences[a].noOfStandardPeriods;
				if (maxPeriodLength < noOfStandardPeriods) {
					maxPeriodLength = noOfStandardPeriods;
				}
			}

			let periodsDetails = calendar.periodsDetails
			let maxContiguousPeriod = false;
			for (let b = 0; b < periodsDetails.length; b++) {
				let periodArray = periodsDetails[b].periods;
				let contiguousPeriod = 0;
				for (let c = 0; c < periodArray.length; c++) {
					let periodObj = periodArray[c];
					if (periodObj.typeOfPeriod === "period") {
						contiguousPeriod++
					} else if (periodObj.typeOfPeriod === "lunch") {
						if (maxPeriodLength <= contiguousPeriod) {
							maxContiguousPeriod = true;
							return maxContiguousPeriod;
						} else {
							contiguousPeriod = 0;
						}
					}

					if (c === periodArray.length - 1) {
						if (maxPeriodLength <= contiguousPeriod) {
							maxContiguousPeriod = true;
							return maxContiguousPeriod;
						}
					}
				}
			}
			return maxContiguousPeriod
		}
	}

	sumOfMultiperiodsValidation = (multiPeriod) => {
		const i18n = this.props.i18n
		let sumOfMultiperiodsValidation = true;
		let cellData = this.props.dataTableMap.get(this.props.cellCode);
		if (cellData.totalPeriod === undefined) {
			toast(i18n.multiPeriodRules.enterTotalPeriod)
			sumOfMultiperiodsValidation = false;
			return sumOfMultiperiodsValidation;
		} else {
			let totalPeriodsCount = cellData.totalPeriod.count;
			let sumOfMultiPeriods = 0;
			for (let i = 0; i < multiPeriod.preferences.length; i++) {
				let preferences = multiPeriod.preferences[i];
				sumOfMultiPeriods += (preferences.noOfStandardPeriods * preferences.numberOfInstances);
			}
			if (sumOfMultiPeriods > totalPeriodsCount) {
				toast(i18n.multiPeriodRules.sumOfMultiPeriod)
				sumOfMultiperiodsValidation = false;
				return sumOfMultiperiodsValidation;
			}
		}
		return sumOfMultiperiodsValidation;
	}

	addMore = () => {
		let valuesObj = {
			noOfStandardPeriods: 1,
			numberOfInstances: 2,
		}
		let tempAddMore = this.state.multiPeriod;
		tempAddMore.preferences.push(valuesObj);
		this.setState({ multiPeriods: tempAddMore });
	}
	removeMultiPeriod = (key) => {
		let multiPeriod = this.state.multiPeriod;
		multiPeriod.preferences.splice(key, 1);
		if (multiPeriod.preferences.length === 0) {
			this.deleteObjFromMultiPeriod()
		}
		this.setState({ multiPeriod: multiPeriod });
	};
	deleteObjFromMultiPeriod() {
		let multiPeriods = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].multiPeriods
		for (let i = 0; i < multiPeriods.length; i++) {
			let multiPeriodObj = multiPeriods[i]
			if (multiPeriodObj.preferences.length === 0) {
				multiPeriods.splice(i, 1)
				i = -1
			}
		}
	}
	render() {
		return (
			<MuiGrid>
				<MultiPeriodRulesComponent
					{...this.props}
					{...this.state}
					handleChange={this.handleChange}
					onClickOfSave={this.onClickOfSave}
					addMore={this.addMore}
					removeMultiPeriod={this.removeMultiPeriod}
				/>
			</MuiGrid>
		)
	}
}
export default MultiPeriodRulesContainer

